import { render, staticRenderFns } from "./ProductsBySellerReadOnlyModal.vue?vue&type=template&id=208f28b0&scoped=true&"
import script from "./ProductsBySellerReadOnlyModal.vue?vue&type=script&lang=ts&"
export * from "./ProductsBySellerReadOnlyModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsBySellerReadOnlyModal.vue?vue&type=style&index=0&id=208f28b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f28b0",
  null
  
)

export default component.exports